import style from "./alert.module.css";
import { useContext } from "react";
import { AppContext } from "../../../contexts/AppContext";
import Alert from "./components/Alert/Alert";

export interface AlertBlock {
  data: AlertData;
  id: number;
}
export type AlertType = "notification" | "error" | "success";

export interface AlertData {
  title: string;
  text: string;
  time?: number;

  type: AlertType;

  closeButton?: boolean;
}

function AlertManager() {
  const { alerts } = useContext(AppContext);

  return (
    <div className={style.wrapper}>
      {alerts.map((alert: AlertBlock, index: number) => (
        <Alert key={index} {...alert} />
      ))}
    </div>
  );
}
export default AlertManager;
